

/* tslint:disable */



export enum SelectionBehavior {
    And = 1,
    ExactlyOne = 2,
    OneOrMore = 3,

}


